/* SIZESOFTX
=========================================================================================
* Descripción: Menú de acciones del catélogo de Almacenes Exhibidores
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* ---------------------------------------------------------------------------------------
*/

import TextField from "../../ui/TextField";
import { Fragment, useEffect } from 'react';
import { useDoubleClickPrevention } from '../../../hooks/useDoubleClickPrevention';
import { Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from "@mui/icons-material/Refresh";

import SizeSoftXModal from "../../leyout/SizeSoftXModal.jsx";

import { useAlmacenesExhibidores } from "../../../context/Catalogos/AlmacenesExhibidoresContext";

export default function MnuAlmacenesExhibidoresActions() {
    const {
        handleClickRegresarMainDashboard,
        handleClickNuevoAlmacenesExhibidores,
        handleClickGuardarAlmacenesExhibidores,
        handleClickEliminarAlmacenesExhibidores,
        handleClickRefrescarDatos,
        statusEditAlmacenesExhibidores,
        almacenesExhibidoresSeleccionado,
        statusOpenModalEliminarAlmacenesExhibidores,
        setStatusOpenModalEliminarAlmacenesExhibidores,
    } = useAlmacenesExhibidores();

    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    // Determinar si hay un almacén seleccionado para habilitar el botón de eliminar
    const NOMBRES_PROTEGIDOS = ["DEFECTOS", "APARTADOS", "ALMACEN1"];

    const hayAlmacenSeleccionado = almacenesExhibidoresSeleccionado &&
                                  almacenesExhibidoresSeleccionado.AlmacenExhibidor &&
                                  almacenesExhibidoresSeleccionado.AlmacenExhibidor.trim().length > 0;

    const esAlmacenProtegido = hayAlmacenSeleccionado &&
        NOMBRES_PROTEGIDOS.includes(almacenesExhibidoresSeleccionado.AlmacenExhibidor.trim().toUpperCase());

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Nuevo'}>
                <IconButton disabled={isProcessing || !statusEditAlmacenesExhibidores} onClick={() => executeWithProtection(handleClickNuevoAlmacenesExhibidores)}>
                    <AddIcon className="icon" /><p className="icon">Nuevo</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Guardar'}>
                <IconButton disabled={isProcessing || statusEditAlmacenesExhibidores} onClick={() => executeWithProtection(handleClickGuardarAlmacenesExhibidores)}>
                    <SaveIcon className="icon" /><p className="icon">Guardar</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={!hayAlmacenSeleccionado ? 'Seleccione un almacén para eliminar' : esAlmacenProtegido ? 'Este almacén es del sistema y no puede eliminarse' : 'Eliminar'}>
                <span>
                <IconButton
                    disabled={isProcessing || !hayAlmacenSeleccionado || esAlmacenProtegido}
                    onClick={() => executeWithProtection(() => setStatusOpenModalEliminarAlmacenesExhibidores(true))}>
                    <DeleteIcon className="icon" /><p className="icon">Eliminar</p>
                </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={'Refrescar'}>
                <IconButton onClick={handleClickRefrescarDatos}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip>

            <SizeSoftXModal
                open={statusOpenModalEliminarAlmacenesExhibidores}
                title={"¿Está seguro de querer eliminar el almacén exhibidor? Esta acción no se puede deshacer."}
                onClose={() => setStatusOpenModalEliminarAlmacenesExhibidores(false)}
                onSuccess={() => executeWithProtection(handleClickEliminarAlmacenesExhibidores)}
                success="Eliminar"
            />
        </Fragment>
    );
}
